<template>
  <div class="motions-list">
    <table class="pure-table pure-table-striped">
      <thead role="rowgroup" >
      <tr role="row">
        <th role="cell">Name</th>
        <th role="cell">State</th>
      </tr>
      </thead>
      <tbody role="rowgroup">
        <tr v-for="motion in motions" :key="motion.id">
          <td class="p-p-3">
            <span class="motion-name">{{motion.name}}</span>
          </td>
          <td>
            <div class="p-d-flex p-ai-center">
              <span v-if="motion.isActive()">
                <span class="blob green"/>
              </span>
              <motion-state-display
                :state="motion.state"
                :reason="motion.stateReason"
                :hide-if-pending="true"
              />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MotionStateDisplay from './MotionStateDisplay.vue'
export default {
  name: 'MotionsList',
  components: {
    MotionStateDisplay
  },
  props: {
    motions: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.motions-list table {
  width: 100%;
  font-size: 0.8rem;
}
.motion-name {
  font-size: 1.1rem;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/motions/MotionsList.vue